import { get, reduce } from 'lodash'

export const getFormId = state => get(state, 'formSettings.formId')
export const getSubdomain = state => get(state, 'formSettings.subdomain')
export const getFormType = state => get(state, 'formSettings.formType')
export const getOrganisationId = state => get(state, 'formSettings.organisationId')
export const getFormSettings = state => get(state, 'formSettings')
export const getFormColorSettings = state => {
  const setting = getFormSettings(state)
  return reduce(
    setting,
    (acc, value, key) => {
      if (key.toLowerCase().includes('color')) {
        acc[key] = value
      }
      return acc
    },
    {}
  )
}
export const getFormTimezone = state => {
  const setting = getFormSettings(state)
  return setting.timezone
}
// For footer data
export const getPaymentProviders = state => {
  const setting = getFormSettings(state)
  const paymentProviders = []
  setting.paymentGateway.reverse().forEach(item => {
    if (item.name.toLowerCase() === 'braintree') {
      const data = { ...item }
      delete data.childGateway

      if (item.childGateways) {
        item.childGateways.forEach(child => {
          if (child.name.toLowerCase() === 'paypal') {
            paymentProviders.push({
              ...child,
            })
          }
        })
      }

      paymentProviders.push({
        ...data,
      })
      return
    }

    paymentProviders.push(item)
  })
  return paymentProviders
}
export const getPaymentGateways = state => {
  const setting = getFormSettings(state)
  const paymentGateways = []
  setting.paymentGateway.forEach(item => {
    const { orderNumber = 1 } = item

    if (item.name.toLowerCase() === 'braintree' && item.childGateways) {
      item.childGateways.forEach((child, i) => {
        if (child.name.toLowerCase() === 'paypal') {
          paymentGateways.push({
            ...child,
            parentId: item.sfid,
            currency: item.currency,
            orderNumber: orderNumber * 10 + i + 1,
          })
        }
      })
    }

    paymentGateways.push({
      ...item,
      orderNumber: orderNumber * 10,
    })
  })

  return paymentGateways
}
export const getOrganisationWithVoucherConfig = state => {
  const organisation = get(state, 'formInfo.organisation')
  const selfOrg = get(state, 'formInfo.organisationsInfo')
    .filter(org => org.sfid === organisation.sfid)
    .shift()
  return {
    ...organisation,
    voucherConfig: selfOrg ? selfOrg.voucherConfig : [],
  }
}
